import { render, staticRenderFns } from "./xskPicturemanage.vue?vue&type=template&id=2975f9cf&scoped=true&"
import script from "./xskPicturemanage.vue?vue&type=script&lang=js&"
export * from "./xskPicturemanage.vue?vue&type=script&lang=js&"
import style0 from "./xskPicturemanage.vue?vue&type=style&index=0&id=2975f9cf&prod&lang=less&"
import style1 from "./xskPicturemanage.vue?vue&type=style&index=1&id=2975f9cf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975f9cf",
  null
  
)

export default component.exports